
import { mapGetters } from "vuex";
import PosControleService from "@/modules/PosControle/services/PosControleService";

const dataLocal = (data) => {
  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
};
const hoje = () => dataLocal(new Date());
const diasAtras = (dias) => {
  const data = new Date();
  data.setDate(data.getDate() - dias);
  return dataLocal(data);
};

export default {
  name: "app-pos-controle",
  data() {
    return {
      abaAtiva: 0,
      carregandoConfiguracao: false,
      salvandoConfiguracao: false,
      testandoConexao: false,
      importandoBase: false,
      importacaoInicialResultado: null,
      mostrarSenha: false,
      mostrarChaveOcp: false,
      configurado: false,
      possuiSenha: false,
      possuiChaveOcp: false,
      origemCredenciais: null,
      integracao: {},
      configForm: {
        username: "",
        password: "",
        chave_ocp: "",
        ativo: true,
        sincronizar_grupos: false,
        sincronizar_produtos: false,
        sincronizar_vendas: false,
        emitir_nfce_automaticamente: false,
        movimentar_estoque: false,
        gerar_financeiro: false,
      },
      carregandoCatalogo: false,
      catalogoCarregado: false,
      sincronizandoCatalogo: false,
      grupos: [],
      produtos: [],
      gruposSelecionados: [],
      produtosSelecionados: [],
      buscaGrupo: "",
      buscaProduto: "",
      catalogoResultado: null,
      baixandoCatalogo: false,
      catalogoDownloadResultado: null,
      carregandoVendas: false,
      vendasCarregadas: false,
      sincronizandoVendas: false,
      vendas: [],
      paginaVendas: 1,
      paginacaoVendas: { total: 0, per_page: 25, last_page: 1 },
      filtrosVendas: {
        data_inicial: diasAtras(7),
        data_final: hoje(),
        status_remoto: "",
        serial_number: "",
        busca: "",
      },
      vendasResultado: null,
      carregandoDetalhe: false,
      vendaDetalhe: null,
    };
  },
  computed: {
    ...mapGetters(["itsblocked"]),
    statusConexaoClass() {
      if (!this.configurado) return "badge-light-warning";
      return this.configForm.ativo ? "badge-success" : "badge-light-secondary";
    },
    statusConexaoLabel() {
      if (!this.configurado) return "Não configurado";
      return this.configForm.ativo
        ? "Configurado e ativo"
        : "Integração inativa";
    },
    configuracaoBotaoLabel() {
      return this.configurado ? "Atualizar dados" : "Salvar configuração";
    },
    origemCredenciaisLabel() {
      if (this.origemCredenciais === "integracao")
        return "salvas nesta integração";
      if (this.origemCredenciais === "configuracao_pos")
        return "reaproveitadas do terminal POS";
      return "ainda não informadas";
    },
    descricaoSenha() {
      return this.possuiSenha
        ? "Já existe uma senha salva. Deixe vazio para mantê-la."
        : "Informe uma senha para configurar a conexão com o POS Controle.";
    },
    descricaoChaveOcp() {
      return this.possuiChaveOcp
        ? "Já existe uma CHAVE OCP salva. Deixe vazio para mantê-la."
        : "Obrigatória para autenticar as requisições na API do POS Controle.";
    },
    importacaoInicialErros() {
      if (!this.importacaoInicialResultado) return [];
      const catalogo = this.importacaoInicialResultado.catalogo || {};
      const grupos = catalogo.grupos?.erros || [];
      const produtos = catalogo.produtos?.erros || [];
      const vendas = this.importacaoInicialResultado.vendas?.erros || [];
      return grupos
        .map(
          (item) =>
            `Grupo ${item.nome ? `"${item.nome}"` : item.id_remoto}: ${
              item.erro
            }`
        )
        .concat(
          produtos.map(
            (item) =>
              `Produto ${item.nome ? `"${item.nome}"` : item.id_remoto}: ${
                item.erro
              }`
          ),
          vendas.map(
            (item) => `Venda ${item.sale_id || "sem ID"}: ${item.erro}`
          )
        );
    },
    importacaoInicialVariant() {
      return this.importacaoInicialErros.length ? "warning" : "success";
    },
    importacaoInicialMensagem() {
      if (!this.importacaoInicialResultado) return "";
      const catalogo = this.importacaoInicialResultado.catalogo || {};
      const grupos = catalogo.grupos || {};
      const produtos = catalogo.produtos || {};
      const vendas = this.importacaoInicialResultado.vendas || {};
      return `${grupos.criados || 0} grupo(s) e ${
        produtos.criados || 0
      } produto(s) criado(s); ${grupos.atualizados || 0} grupo(s) e ${
        produtos.atualizados || 0
      } produto(s) atualizado(s); ${
        vendas.processadas || 0
      } venda(s) do mês processada(s).`;
    },
    gruposFiltrados() {
      const busca = this.normalizar(this.buscaGrupo);
      if (!busca) return this.grupos;
      return this.grupos.filter((grupo) =>
        this.normalizar(grupo.nome).includes(busca)
      );
    },
    produtosFiltrados() {
      const busca = this.normalizar(this.buscaProduto);
      const produtos = busca
        ? this.produtos.filter((produto) =>
            this.normalizar(
              `${produto.codigo} ${produto.descricao} ${produto.grupo || ""}`
            ).includes(busca)
          )
        : this.produtos;

      return produtos.slice(0, 300);
    },
    totalProdutosFiltrados() {
      const busca = this.normalizar(this.buscaProduto);
      if (!busca) return this.produtos.length;
      return this.produtos.filter((produto) =>
        this.normalizar(
          `${produto.codigo} ${produto.descricao} ${produto.grupo || ""}`
        ).includes(busca)
      ).length;
    },
    todosGruposVisiveisSelecionados() {
      return (
        this.gruposFiltrados.length > 0 &&
        this.gruposFiltrados.every((item) =>
          this.gruposSelecionados.includes(item.id)
        )
      );
    },
    todosProdutosVisiveisSelecionados() {
      return (
        this.produtosFiltrados.length > 0 &&
        this.produtosFiltrados.every((item) =>
          this.produtosSelecionados.includes(item.id)
        )
      );
    },
    possuiSelecaoCatalogo() {
      return (
        this.gruposSelecionados.length > 0 ||
        this.produtosSelecionados.length > 0
      );
    },
    catalogoErros() {
      if (!this.catalogoResultado) return [];
      const grupos =
        (this.catalogoResultado.grupos &&
          this.catalogoResultado.grupos.erros) ||
        [];
      const produtos =
        (this.catalogoResultado.produtos &&
          this.catalogoResultado.produtos.erros) ||
        [];
      return grupos
        .map((item) => {
          const grupo = this.grupos.find(
            (registro) => Number(registro.id) === Number(item.id)
          );
          return `Grupo ${grupo ? `"${grupo.nome}"` : `#${item.id}`}: ${
            item.erro
          }`;
        })
        .concat(
          produtos.map((item) => {
            const produto = this.produtos.find(
              (registro) => Number(registro.id) === Number(item.id)
            );
            return `Produto ${
              produto ? `"${produto.descricao}"` : `#${item.id}`
            }: ${item.erro}`;
          })
        );
    },
    catalogoTotalSincronizados() {
      if (!this.catalogoResultado) return 0;
      return (
        Number(this.catalogoResultado.grupos?.sincronizados || 0) +
        Number(this.catalogoResultado.produtos?.sincronizados || 0)
      );
    },
    catalogoResultadoVariant() {
      if (!this.catalogoErros.length) return "success";
      return this.catalogoTotalSincronizados ? "warning" : "danger";
    },
    catalogoResultadoMensagem() {
      const grupos = this.catalogoResultado && this.catalogoResultado.grupos;
      const produtos =
        this.catalogoResultado && this.catalogoResultado.produtos;
      const resumo = `${(grupos && grupos.sincronizados) || 0} grupo(s) e ${
        (produtos && produtos.sincronizados) || 0
      } produto(s) sincronizado(s).`;
      if (!this.catalogoErros.length) return resumo;
      if (!this.catalogoTotalSincronizados)
        return "Falha na sincronização: nenhum item foi enviado ao POS Controle.";
      return `Sincronização parcial. ${resumo}`;
    },
    catalogoDownloadErros() {
      if (!this.catalogoDownloadResultado) return [];
      const grupos = this.catalogoDownloadResultado.grupos?.erros || [];
      const produtos = this.catalogoDownloadResultado.produtos?.erros || [];
      return grupos
        .map((item) => "Grupo #" + item.id + ": " + item.erro)
        .concat(
          produtos.map((item) => "Produto #" + item.id + ": " + item.erro)
        );
    },
    catalogoDownloadTotalAtualizados() {
      if (!this.catalogoDownloadResultado) return 0;
      return (
        Number(this.catalogoDownloadResultado.grupos?.atualizados || 0) +
        Number(this.catalogoDownloadResultado.produtos?.atualizados || 0)
      );
    },
    catalogoDownloadVariant() {
      if (!this.catalogoDownloadErros.length) return "success";
      return this.catalogoDownloadTotalAtualizados ? "warning" : "danger";
    },
    catalogoDownloadMensagem() {
      if (!this.catalogoDownloadResultado) return "";
      const grupos = this.catalogoDownloadResultado.grupos || {};
      const produtos = this.catalogoDownloadResultado.produtos || {};
      const semAlteracao =
        Number(grupos.sem_alteracao || 0) + Number(produtos.sem_alteracao || 0);
      const naoMapeados =
        Number(grupos.nao_mapeados || 0) + Number(produtos.nao_mapeados || 0);

      return (
        (grupos.atualizados || 0) +
        " grupo(s) e " +
        (produtos.atualizados || 0) +
        " produto(s) atualizados no Nuts; " +
        semAlteracao +
        " sem alteração e " +
        naoMapeados +
        " item(ns) do POS sem vínculo ignorado(s)."
      );
    },
    vendasResultadoVariant() {
      if (!this.vendasResultado) return "success";
      if (Number(this.vendasResultado.pendentes || 0) > 0) return "warning";
      return this.vendasResultado.erros && this.vendasResultado.erros.length
        ? "warning"
        : "success";
    },
    vendasResultadoMensagem() {
      if (!this.vendasResultado) return "";
      return `${this.vendasResultado.consultadas || 0} consultada(s), ${
        this.vendasResultado.criadas || 0
      } nova(s), ${this.vendasResultado.atualizadas || 0} atualizada(s) e ${
        this.vendasResultado.canceladas || 0
      } cancelada(s); ${
        this.vendasResultado.processadas || 0
      } documento(s) Nuts processado(s) e ${
        this.vendasResultado.pendentes || 0
      } pendente(s).`;
    },
    itensVendaDetalhe() {
      const payload = (this.vendaDetalhe && this.vendaDetalhe.payload) || {};
      return payload.SaleItems || payload.saleItems || payload.Items || [];
    },
    pagamentosVendaDetalhe() {
      const payload = (this.vendaDetalhe && this.vendaDetalhe.payload) || {};
      return (
        payload.SalePaymentType ||
        payload.salePaymentType ||
        payload.Payments ||
        []
      );
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
      return;
    }
    const aba = this.$route.query.aba;
    this.abaAtiva = aba === "catalogo" ? 1 : aba === "vendas" ? 2 : 0;
    this.carregarConfiguracao();
    if (this.abaAtiva === 1) this.carregarCatalogo();
    if (this.abaAtiva === 2) this.buscarVendas();
  },
  methods: {
    alterarAba(index) {
      const aba = ["conexao", "catalogo", "vendas"][index] || "conexao";
      if (this.$route.query.aba !== aba) {
        this.$router
          .replace({ query: { ...this.$route.query, aba } })
          .catch(() => {});
      }
      if (index === 1 && !this.catalogoCarregado) this.carregarCatalogo();
      if (index === 2 && !this.vendasCarregadas) this.buscarVendas();
    },
    async carregarConfiguracao() {
      this.carregandoConfiguracao = true;
      try {
        const response = await PosControleService.configuracao();
        const resumo = response.data.data || {};
        this.configurado = !!resumo.configurado;
        this.possuiSenha = !!resumo.possui_senha;
        this.possuiChaveOcp = !!resumo.possui_chave_ocp;
        this.origemCredenciais = resumo.origem_credenciais || null;
        this.integracao = resumo.integracao || {};
        this.configForm.ativo = this.integracao.ativo !== false;
        this.configForm.sincronizar_grupos =
          !!this.integracao.sincronizar_grupos;
        this.configForm.sincronizar_produtos =
          !!this.integracao.sincronizar_produtos;
        this.configForm.sincronizar_vendas =
          !!this.integracao.sincronizar_vendas;
        this.configForm.movimentar_estoque =
          !!this.integracao.movimentar_estoque;
        this.configForm.gerar_financeiro = !!this.integracao.gerar_financeiro;
        this.configForm.emitir_nfce_automaticamente =
          !!this.integracao.emitir_nfce_automaticamente;
      } finally {
        this.carregandoConfiguracao = false;
      }
    },
    async salvarConfiguracao() {
      if (!this.possuiChaveOcp && !this.configForm.chave_ocp) {
        this.$toast.warning("Informe a CHAVE OCP da integração POS Controle.");
        return;
      }

      this.salvandoConfiguracao = true;
      try {
        const payload = {
          ativo: this.configForm.ativo,
          sincronizar_grupos: this.configForm.sincronizar_grupos,
          sincronizar_produtos: this.configForm.sincronizar_produtos,
          sincronizar_vendas: this.configForm.sincronizar_vendas,
          movimentar_estoque: this.configForm.movimentar_estoque,
          gerar_financeiro: this.configForm.gerar_financeiro,
          emitir_nfce_automaticamente: this.configForm.emitir_nfce_automaticamente,
        };
        if (this.configForm.username)
          payload.username = this.configForm.username;
        if (this.configForm.password)
          payload.password = this.configForm.password;
        if (this.configForm.chave_ocp)
          payload.chave_ocp = this.configForm.chave_ocp;
        await PosControleService.salvarConfiguracao(payload);
        this.configForm.password = "";
        this.configForm.chave_ocp = "";
        this.$toast.success("Configuração do POS Controle salva.");
        await this.carregarConfiguracao();
      } finally {
        this.salvandoConfiguracao = false;
      }
    },
    async testarConexao() {
      this.testandoConexao = true;
      try {
        await PosControleService.testarConexao();
        this.$toast.success(
          "Conexão com o POS Controle realizada com sucesso."
        );
        this.configurado = true;
      } finally {
        this.testandoConexao = false;
      }
    },
    confirmarImportacaoInicial() {
      return this.$swal
        .fire({
          icon: "warning",
          title: "Importar a base do POS Controle?",
          text: "Serão criados ou atualizados grupos e produtos no Nuts e importadas as vendas do mês atual. As opções de estoque e financeiro configuradas serão aplicadas.",
          showCancelButton: true,
          confirmButtonText: "Importar agora",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) return this.executarImportacaoInicial();
          return null;
        });
    },
    async executarImportacaoInicial() {
      this.importandoBase = true;
      this.importacaoInicialResultado = null;
      try {
        const response = await PosControleService.importarBaseInicial();
        this.importacaoInicialResultado = response.data.data;
        if (this.importacaoInicialErros.length) {
          this.$toast.warning("Importação inicial concluída com pendências.");
        } else {
          this.$toast.success("Base do POS Controle importada com sucesso.");
        }
        await this.carregarConfiguracao();
      } finally {
        this.importandoBase = false;
      }
    },
    async carregarCatalogo() {
      this.carregandoCatalogo = true;
      try {
        const [gruposResponse, produtosResponse] = await Promise.all([
          PosControleService.listarGrupos(),
          PosControleService.listarProdutos(),
        ]);
        const gruposPayload = gruposResponse.data.data || gruposResponse.data;
        const produtosPayload =
          produtosResponse.data.data || produtosResponse.data;
        this.grupos = Array.isArray(gruposPayload)
          ? gruposPayload
          : gruposPayload.data || [];
        this.produtos = Array.isArray(produtosPayload)
          ? produtosPayload
          : produtosPayload.data || [];
        this.catalogoCarregado = true;
      } finally {
        this.carregandoCatalogo = false;
      }
    },
    selecionarGruposVisiveis(selecionar) {
      const ids = this.gruposFiltrados.map((item) => item.id);
      this.gruposSelecionados = selecionar
        ? Array.from(new Set(this.gruposSelecionados.concat(ids)))
        : this.gruposSelecionados.filter((id) => !ids.includes(id));
    },
    selecionarProdutosVisiveis(selecionar) {
      const ids = this.produtosFiltrados.map((item) => item.id);
      this.produtosSelecionados = selecionar
        ? Array.from(new Set(this.produtosSelecionados.concat(ids)))
        : this.produtosSelecionados.filter((id) => !ids.includes(id));
    },
    sincronizarSelecionados() {
      return this.executarSincronizacaoCatalogo({
        grupo_ids: this.gruposSelecionados,
        produto_ids: this.produtosSelecionados,
      });
    },
    sincronizarTudo() {
      return this.$swal
        .fire({
          icon: "question",
          title: "Sincronizar todo o catálogo ativo?",
          text: "O tempo de processamento depende da quantidade de produtos.",
          showCancelButton: true,
          confirmButtonText: "Sincronizar",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed)
            return this.executarSincronizacaoCatalogo({ todos: true });
          return null;
        });
    },
    async executarSincronizacaoCatalogo(payload) {
      this.sincronizandoCatalogo = true;
      this.catalogoResultado = null;
      try {
        const response = await PosControleService.sincronizarCatalogo(payload);
        this.catalogoResultado = response.data.data;
        if (this.catalogoErros.length && !this.catalogoTotalSincronizados)
          this.$toast.error(
            "A sincronização falhou. Consulte o motivo destacado na tela."
          );
        else if (this.catalogoErros.length)
          this.$toast.warning("Sincronização concluída com pendências.");
        else this.$toast.success("Catálogo sincronizado com sucesso.");
      } finally {
        this.sincronizandoCatalogo = false;
      }
    },
    baixarAlteracoesCatalogo() {
      return this.$swal
        .fire({
          icon: "question",
          title: "Baixar alterações do POS Controle?",
          text: "Os dados do POS substituirão nome dos grupos e nome, código interno, preço, código de barras, status e grupo dos produtos já vinculados.",
          showCancelButton: true,
          confirmButtonText: "Baixar e atualizar Nuts",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) return this.executarDownloadCatalogo();
          return null;
        });
    },
    async executarDownloadCatalogo() {
      this.baixandoCatalogo = true;
      this.catalogoDownloadResultado = null;
      try {
        const response = await PosControleService.baixarCatalogo();
        this.catalogoDownloadResultado = response.data.data;
        if (
          this.catalogoDownloadErros.length &&
          !this.catalogoDownloadTotalAtualizados
        ) {
          this.$toast.error(
            "Não foi possível baixar as alterações. Consulte os erros na tela."
          );
        } else if (this.catalogoDownloadErros.length) {
          this.$toast.warning("Alterações baixadas parcialmente.");
        } else {
          this.$toast.success("Alterações do POS aplicadas no Nuts.");
        }
        await this.carregarCatalogo();
      } finally {
        this.baixandoCatalogo = false;
      }
    },
    async buscarVendas() {
      this.carregandoVendas = true;
      try {
        const response = await PosControleService.listarVendas({
          ...this.filtrosVendas,
          page: this.paginaVendas,
          per_page: this.paginacaoVendas.per_page,
        });
        const pagina = response.data.data || {};
        this.vendas = pagina.data || [];
        this.paginacaoVendas = {
          total: Number(pagina.total || 0),
          per_page: Number(pagina.per_page || 25),
          last_page: Number(pagina.last_page || 1),
        };
        this.vendasCarregadas = true;
      } finally {
        this.carregandoVendas = false;
      }
    },
    aplicarFiltrosVendas() {
      this.paginaVendas = 1;
      return this.buscarVendas();
    },
    mudarPaginaVendas(pagina) {
      this.paginaVendas = pagina;
      this.$nextTick(() => this.buscarVendas());
    },
    async sincronizarPeriodoVendas() {
      this.sincronizandoVendas = true;
      this.vendasResultado = null;
      try {
        const response = await PosControleService.sincronizarVendas({
          data_inicial: this.filtrosVendas.data_inicial || null,
          data_final: this.filtrosVendas.data_final || null,
        });
        this.vendasResultado = response.data.data;
        this.paginaVendas = 1;
        await this.buscarVendas();
        this.$toast.success("Busca de vendas concluída.");
      } finally {
        this.sincronizandoVendas = false;
      }
    },
    async abrirDetalheVenda(id) {
      this.vendaDetalhe = null;
      this.carregandoDetalhe = true;
      this.$bvModal.show("pos-controle-venda-detalhe");
      try {
        const response = await PosControleService.detalharVenda(id);
        this.vendaDetalhe = response.data.data;
      } finally {
        this.carregandoDetalhe = false;
      }
    },
    normalizar(value) {
      return String(value || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    documentoClienteVenda(venda) {
      const digitos = String(venda?.documento_cliente || "").replace(/\D/g, "");
      if (!digitos || /^0+$/.test(digitos)) return "";
      return [11, 14].includes(digitos.length) ? digitos : "";
    },
    formatarMoeda(value) {
      const numero = Number(String(value || 0).replace(",", "."));
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number.isFinite(numero) ? numero : 0);
    },
    formatarData(value) {
      if (!value) return "—";
      const data = new Date(value);
      if (Number.isNaN(data.getTime())) return value;
      return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(data);
    },
    statusVendaLabel(venda) {
      if (
        Number(venda.status_remoto) === 3 ||
        venda.status_processamento === "cancelada"
      )
        return "Cancelada";
      if (venda.status_processamento === "erro") return "Erro";
      if (venda.status_processamento === "processada") return "Processada";
      return "Importada";
    },
    statusVendaClass(venda) {
      if (
        Number(venda.status_remoto) === 3 ||
        venda.status_processamento === "cancelada"
      )
        return "badge-light-danger";
      if (venda.status_processamento === "erro") return "badge-light-warning";
      if (venda.status_processamento === "processada")
        return "badge-light-success";
      return "badge-light-primary";
    },
    nomeItemVenda(item) {
      return (
        item.ProductName ||
        item.Name ||
        item.Description ||
        item.InternalCode ||
        "Produto"
      );
    },
    totalItemVenda(item) {
      return (
        Number(item.Quantity || 0) *
        Number(item.UnitPrice || item.PriceAmount || 0)
      );
    },
  },
};
